export const MAIN_PAGE = 'MAIN_PAGE'
export const FLOOR_PLAN = 'FLOOR_PLAN'
export const WORKSPACE_SHOW = 'WORKSPACE_SHOW'
export const BUILDING_LIST = 'BUILDING_LIST'
export const MEETING_SPACES_SEQUENCE = 'MEETING_SPACES_SEQUENCE'
export const MEETING_SPACES_SHOW = 'MEETING_SPACES_SHOW'
export const SERVICE_SEQUENCE = 'SERVICE_SEQUENCE'
export const SERVICE_REQUEST_DETAIL = 'SERVICE_REQUEST_DETAIL'
export const MOVE_SEQUENCE = 'MOVE_SEQUENCE'
export const LOGON_CONTAINER = 'LOGON_CONTAINER'
export const DASHBOARD = 'DASHBOARD'
export const MEETING_SPACE = 'MEETING_SPACE'
export const WORKSPACE = 'WORKSPACE'
export const WORKSPACELIST = 'WORKSPACELIST'
export const CONFERENCE_ROOM = 'CONFERENCE_ROOM'
export const HOME = 'HOME'
export const KIOSK_CONTAINER = 'KIOSK_CONTAINER'
export const REGISTER_KIOSK = 'REGISTER_KIOSK'
export const SERVICE_CATALOG = 'SERVICE_CATALOG'

export const MEETING_SCHEDULE = 'MEETING_SCHEDULE'
export const MEETING_CREATE = 'MEETING_CREATE'
export const MEETING_LIST = 'MEETING_LIST'
export const MEETING_CONFIRMATION = 'MEETING_CONFIRMATION'
